import { createFileRoute } from '@tanstack/react-router'
import { SharedPage } from '@thom/folio-ui/pages/share'

export const Route = createFileRoute('/share/$token')({
	component: SharedPage,
})
